export class GlobalConstants {
    public static photosServerPath: string = "https://mnb-photos.azurewebsites.net";
      
    public static siteTitle: string = "This is example of ItSolutionStuff.com";
}